import React from 'react'
import { Modal } from '@zambezi/sdk/modal'

import modalStyle from '@apiEnabler/ob-common/lib/view/modal.module.css'

const ServiceProviderInfoModal = ({ open, onCancel }) => (
  <Modal
    className={`${modalStyle.modal} js-modal`}
    withBackdrop
    withPadding
    open={open}
    title="Service Provider"
    confirm="Close"
    onCancel={onCancel}
    onConfirm={onCancel}
  >
    <p>
      This could either be the name of the app or website you’re using or buying
      goods or services from, or the name of the service provider they use to
      manage their service.
    </p>
    <ul>
      <li>
        An Account Information Service Provider (AISP) can see your payment
        account data with your consent. Example uses include budgeting apps that
        can analyse your spending, applying for credit and seeing all your
        payment account information from different bank accounts in one place
        online or via a mobile app.
      </li>
      <li>
        A Payment Initiation Service Provider (PISP) lets you pay companies
        directly from your bank account with your consent rather than using your
        debit or credit card through a service-provider such as Visa or
        MasterCard.
      </li>
    </ul>
    <p>
      These service providers must be authorised or registered with the
      Financial Conduct Authority and if in doubt{' '}
      <a
        href="https://register.fca.org.uk/s/search?predefined=AIPISP"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="More information about how to report a fraud, an external link that will open in a new tab"
      >
        check the Financial Services Register
      </a>
      .
    </p>
  </Modal>
)

export default ServiceProviderInfoModal
